import { ILoadFeaturedAction, IAction, IToggleLoginAction, IAuthenticationStatus } from "./actions";
import { container } from "src/inversify.config";
import HomeDataService from "../components/home/home.data.service";
import { AppThunkAction } from "../typings";

const LOAD_FEATURED = "LOAD_FEATURED";
const LAUNCH_LOGIN = "LAUNCH_LOGIN";
const LAUNCH_SIGN_UP = "LAUNCH_SIGN_UP";
const OPEN_LOGIN_MODAL = "OPEN_LOGIN_MODAL";
const CHANGE_AUTH_STATUS = "CHANGE_AUTH_STATUS";

export const actions = {
    changeAuthenticationStatus: (value: boolean): AppThunkAction<IAuthenticationStatus> => {
        return (dispatch, getState) => {
            dispatch({ type: CHANGE_AUTH_STATUS, value });
        };
    },
    toggleLogin: (value: boolean, inPage: number, preferedRole?: number): AppThunkAction<IToggleLoginAction> => {
        return (dispatch, getState) => {
            dispatch({ type: OPEN_LOGIN_MODAL, value, inPage, preferedRole });
        };
    },
    loadFeatured: (): AppThunkAction<ILoadFeaturedAction> => {
        return (dispatch, getState) => {
            var dataService = container.get(HomeDataService);

            dataService.getFeatured().then((result) => {
                dispatch({ type: LOAD_FEATURED, featured: result });
            });
        };
    },
};



// WEBPACK FOOTER //
// ./src/actions/home.actions.ts